
    import { mapState } from 'vuex';
    import JobCardBasicShimmer from '@/components/Job/JobCard/JobCardBasicShimmer';

    export default {
        name: 'JobSlideLoading',

        components: {
            JobCardBasicShimmer,
        },

        data() {
            return {
                fakeElements: 5,
                breakpoints: {
                    320: {
                        perView: 1,
                    },

                    576: {
                        perView: 2,
                    },

                    768: {
                        perView: 2,
                    },

                    808: {
                        perView: 3,
                    },

                    992: {
                        perView: 3,
                    },

                    1284: {
                        perView: 4,
                    },

                    1364: {
                        perView: 4,
                    },

                    1500: {
                        perView: 4,
                        peek: 64,
                    },

                    1700: {
                        perView: 5,
                        peek: 64,
                    },

                    1920: {
                        perView: 5,
                    },

                    2198: {
                        perView: 6,
                    },

                    2478: {
                        perView: 7,
                    },

                    3000: {
                        perView: 8,
                    },
                },
            };
        },
        computed: {
            ...mapState({
                $_appInfo: state => state.appInfo,
            }),
        },
        mounted() {
            this.initSlide();
        },
        methods: {
            matchBreakpoint(needle, haystack) {
                return haystack.reduce((a, b) => {
                    if (needle <= a) {
                        return a;
                    }

                    if (needle > a && needle < b) {
                        return a;
                    }

                    if (needle >= b) {
                        return b;
                    }
                });
            },

            getBreakpoint() {
                const container = this.$refs.jobSlideLoading;
                const containerWidth = container.offsetWidth;
                const breakpoints = Object.keys(this.breakpoints);
                const matchBreakpoint = this.matchBreakpoint(containerWidth, breakpoints);
                return this.breakpoints[matchBreakpoint];
            },

            initSlide() {
                if (typeof window === 'undefined') {
                    return;
                }

                this.fakeElements = this.getBreakpoint().perView;
            },
        },
    };
